import { HttpClient, HttpClientModule } from '@angular/common/http';
import { CUSTOM_ELEMENTS_SCHEMA, Injector, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule, TransferState } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SharedModule } from './shared/shared.module';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import { HelpersService } from './shared/services/helpers.service';
import { registerLocaleData } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UsersService } from './shared/services/users.service';
import { CookieService } from 'ngx-cookie-service';
import { CookieModule } from 'ngx-cookie';
import { NodeService } from './shared/services/node.services';
import { SearchPageComponent } from './components/search-page/search-page.component';
import { RedirectAvvisiComponent } from './components/redirect-avvisi/redirect-avvisi.component';
import { SitemapComponent } from './components/sitemap/sitemap.component';
import { SubtreeSitemapComponent } from './components/sitemap/subtree-sitemap/subtree-sitemap.component';
import { CookiePolicyComponent } from './components/cookie-policy/cookie-policy.component';
import { LanguageLoader } from './utility/language-loader';
import { environment } from 'src/environments/environment';


for (let lang of environment.languages) {
  registerLocaleData(lang.locale, lang.codeApi);
}

// tslint:disable-next-line:typedef
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/');
}

@NgModule({
  declarations: [
    AppComponent,
    SearchPageComponent,
    RedirectAvvisiComponent,
    SitemapComponent,
    SubtreeSitemapComponent,
    CookiePolicyComponent
  ],
  imports: [
    HttpClientModule,
    BrowserModule.withServerTransition({ appId: 'serverApp' }),
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    CookieModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useExisting: LanguageLoader,
        // useFactory: translateBrowserLoaderFactory,
        deps: [HttpClient, TransferState]
      }
    }),
  ],
  providers: [
    HelpersService,
    UsersService,
    NodeService,
    TransferState,
    CookieService,
    {
      provide: LOCALE_ID,
      useValue: 'it'
     }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule {}